import createToast from './localToast';

export const toastError = (title: string, message: any) => {
  console.error(message?.message || message);
  createToast('error', title, message?.message || message);
};

export const toastSuccess = (title: string, message: any) => {
  console.info(message?.message || message);
  createToast('success', title, message?.message || message);
};

export const toastWarning = (title: string, message: any) => {
  console.info(message?.message || message);
  createToast('warning', title, message?.message || message);
};
